import type { FinanceRate } from '@kanda-libs/ks-frontend-services';
import FinanceOptionDivider from './Divider';
import LabelHandle from './LabelHandle';
import FinanceOptionRateDetails from './RateDetails';
import useRate from './useRate';

export interface RateProps {
  rates: FinanceRate[];
  toggleable: boolean;
}

const Rate: React.FunctionComponent<RateProps> = function ({
  rates,
  toggleable,
}) {
  const { available, pending, hideUnavailable, showDivider } = useRate(rates);
  if ((!available || pending) && hideUnavailable) return null;
  return (
    <>
      <LabelHandle rates={rates} toggleable={toggleable} />
      <FinanceOptionRateDetails rates={rates} />
      {showDivider && <FinanceOptionDivider />}
    </>
  );
};

export default Rate;
